
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface KnowledgeBaseInfoFieldsProps {
  name: string;
  description: string;
  onChange: (field: string, value: string) => void;
}

export default function KnowledgeBaseInfoFields({
  name,
  description,
  onChange,
}: KnowledgeBaseInfoFieldsProps) {
  return (
    <>
      <div className="grid grid-cols-4 items-center gap-4">
        <Label htmlFor="name" className="text-right">
          Nome
        </Label>
        <Input
          id="name"
          value={name}
          onChange={(e) => onChange("name", e.target.value)}
          className="col-span-3"
        />
      </div>

      <div className="grid grid-cols-4 items-center gap-4">
        <Label htmlFor="description" className="text-right">
          Descrição
        </Label>
        <Textarea
          id="description"
          value={description || ""}
          onChange={(e) => onChange("description", e.target.value)}
          className="col-span-3"
          rows={3}
        />
      </div>
    </>
  );
}
